import Accordion from './accordion';
import Blog from './blog';
import InfoButtons from './info_button';
import LoadMoreButton from './load_more_button';
import LineClamp from './line_clamp';
import NetworkMasonry from './network_masonry';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import Mark from "mark.js";
import Cookies from "js-cookie";

export default class WPAjax {
    constructor(options) {
        console.log("Performing AJAX");
        this.posts = [];
        this.post_ajax(options);
    }
    //scroll to top should be an option here.
    post_ajax(options) {
        var that = this;
        if(options) {
            //if we have selected all, set to an empty string and get all.
            if(options.value) {
                if(options.value === 'All') {
                    options.value = ''
                }
            }

            if(options.loading) {
                // disablePageScroll();
            }

            let post_type = (options.post_type) ? options.post_type : '';
            console.log(post_type + " SELECTED");
            console.log('options are valid with: ', options);
            // console.log('taxonomy: ' + (options.taxonomy) ? options.taxonomy : '');
            let website = window.location.origin + '/wp-json/queries/query_builder';
            jQuery.ajax({
                type: "POST",
                url: website,
                // dataType: 'json',
                data: {
                    post_type: (options.post_type) ? options.post_type : 'post',
                    is_user: (options.is_user) ? options.is_user : false,
                    user_details: (options.user_details) ? options.user_details : undefined,
                    posts_per_page: (options.posts_per_page) ? options.posts_per_page : 10,
                    curr_page: (options.curr_page) ? options.curr_page : 1,
                    categories: (options.categories) ? options.categories : undefined,
                    acf_filters: (options.acf_filters) ? options.acf_filters : undefined,
                    las: (options.las) ? options.las : undefined,
                    work_areas: (options.work_areas) ? options.work_areas : undefined,
                    contact_areas: (options.contact_areas) ? options.contact_areas : undefined,
                    acf_relationship: (options.acf_relationship) ? options.acf_relationship : 'and',
                    order: (options.order) ? options.order : '',
                    order_by: (options.order_by) ? options.order_by : '',
                    search: (options.search) ? options.search : '',
                    search_type: (options.search_type) ? options.search_type : 'and',
                    sorted: (options.sorted) ? options.sorted : false,
                    is_repeater: (options.is_repeater) ? options.is_repeater : false,
                    exclude: (options.exclude) ? options.exclude : false
                },

                success: function (result) {
                    // console.log("GREAT SUCCESS!", JSON.parse(result));
                    console.log("Result: ", result.message);
                    console.log("Query: ", result.query);
                    // that.set_posts(result.data)
                    // that.set_max_posts(result.post_number);
                    if(result.success === true) {
                        that.set_posts(result.data)
                        that.set_max_posts(result.post_number);
                    } else {
                        //enablePageScroll();
                        throw new Error("Could not find any results with query ", result.query);
                    }
                },

                error: function (error) {
                    //enablePageScroll();
                }
            })
            .then(function() {
                console.log("AJAX has been finished")

                that.get_posts_content((options.post_type) ? options.post_type : '',
                                       (options.curr_page) ? options.curr_page : 1,
                                        options,
                                        (options.order_by) ? options.order_by : '',
                                        (options.order_value) ? options.order_value : '');
            });
        }
    }

    get_news_by_search(options) {
        var that = this;
        if(options) {
            //if we have selected all, set to an empty string and get all.
            if(options.value) {
                if(options.value === 'All') {
                    options.value = ''
                }
            }
            let post_type = (options.post_type) ? options.post_type : '';
            console.log(post_type + " SELECTED");
            console.log('options are valid with: ', options);
            // console.log('taxonomy: ' + (options.taxonomy) ? options.taxonomy : '');
            let website = window.location.origin + '/wp-json/queries/news_search';
            jQuery.ajax({
                type: "POST",
                url: website,
                // dataType: 'json',
                data: {
                    post_type: (options.post_type) ? options.post_type : 'post',
                    is_user: (options.is_user) ? options.is_user : false,
                    user_details: (options.user_details) ? options.user_details : undefined,
                    posts_per_page: (options.posts_per_page) ? options.posts_per_page : 10,
                    curr_page: (options.curr_page) ? options.curr_page : 1,
                    categories: (options.categories) ? options.categories : undefined,
                    acf_filters: (options.acf_filters) ? options.acf_filters : undefined,
                    acf_relationship: (options.acf_relationship) ? options.acf_relationship : 'and',
                    order: (options.order) ? options.order : '',
                    order_by: (options.order_by) ? options.order_by : '',
                    search: (options.search) ? options.search : '',
                    search_type: (options.search_type) ? options.search_type : 'and',
                    sorted: (options.sorted) ? options.sorted : false,
                    is_repeater: (options.is_repeater) ? options.is_repeater : false,
                    term: (options.term) ? options.term : options.term,
                    exclude: (options.exclude) ? options.exclude : false,
                    publication: (options.publication) ? options.publication : undefined,
                    theme: (options.theme) ? options.theme : undefined
                },

                success: function (result) {
                    // console.log("GREAT SUCCESS!", JSON.parse(result));
                    console.log("Result: ", result.message);
                    console.log("Query: ", result.query);
                    if(result.success === true) {
                        that.set_posts(result.data)
                        that.set_max_posts(result.post_number);
                    } else {
                        //enablePageScroll();
                        throw new Error("Could not find any results with query ", result.query);
                    }
                },

                error: function(error) {
                    //enablePageScroll();
                    console.log("Error: ", error);
                }
            })
            .then(function() {
                console.log("AJAX has been finished")

                that.get_posts_content((options.post_type) ? options.post_type : '',
                                       (options.curr_page) ? options.curr_page : 1,
                                        options,
                                        (options.order_by) ? options.order_by : '',
                                        (options.order_value) ? options.order_value : '');
            });
        }
    }

    get_posts_content(post_type, curr_page, options, order_by, order_value) {
        var that = this;

        let website = window.location.origin + '/get_posts.php';
        console.log("posts data", this.get_posts());
        let id_array = [];
        this.get_posts().forEach(post => {
            id_array.push(post.ID);
        });
        console.log('IDs: ', id_array);
        jQuery.ajax({
            type: "POST",
            url: website,
            // dataType: 'json',
            data: {
                post_type: (options.is_user === true) ? 'users' : options.post_type,
                ids: id_array,
                order_by: order_by,
                order_value: order_value
            },

            success: function (result) {
                console.log("got posts: ", result);
                //resetting the content div.

                var last_scroll = undefined;
                var previous_height; var this_height; var container_top; var button_text;

                let container = document.getElementById(options.container)
                
                //getting the previous location of the load more button.
                if(options.load_more_button && options.loading) {
                    // let load_more_button = document.getElementById(options.load_more_button_id);
                    // if(load_more_button) {
                        // last_scroll = load_more_button.getBoundingClientRect().top;
                    // }
                    // let container = document.getElementById(options.container);
                    
                    if(container) {
                        last_scroll = window.pageYOffset || document.documentElement.scrollTop;
                        // disablePageScroll();
                        let container_bounds = container.getBoundingClientRect()
                        container_top = container_bounds.top
                        previous_height = container.offsetHeight;
                    }
                }

                document.getElementById(options.container).innerHTML = "";
                var htmlObject = $(result);
                
                // disablePageScroll();
                $('#' + options.container).append(htmlObject);

                if(Cookies.get('searchPostType')) {
                    let id = Cookies.get('searchId');
                    let searchTerm = Cookies.get('searchTerm');
                    let el = document.querySelector(`*[data-id='${id}']`);
                    if (el) {
                        const y = el.getBoundingClientRect().top + window.pageYOffset + -150;
                        window.scrollTo({top: y, behavior: 'smooth'});
                        let instance = new Mark(el);
                        instance.mark(searchTerm);
                    }

                    Cookies.remove('searchTerm')
                    Cookies.remove('searchPostType');
                    Cookies.remove('searchId');
                }

                //getting the previous location of the load more button.
                // if(options.load_more_button) {
                //     let load_more_button = document.getElementById(options.load_more_button_id);
                //     if(load_more_button) {
                //         last_scroll = window.scrollY;
                //     }
                // }

                // if(last_scroll) {
                // }
                // //enablePageScroll();

                let research_holder = document.getElementById('blog-grid-content');
                if(research_holder && options.posts_per_page === -1) {
                    console.log("Removing border.");
                    //only if on mobile.
                    if(window.innerWidth <= 1200) {
                        let last_research = research_holder.lastElementChild.getElementsByClassName("post-item")[0];
                        last_research.style.borderBottom = 'none';
                    }
                }

                if(options.load_more_button) {
                    LoadMoreButton.init(options.load_more_button_id, that.get_max_posts(), that.get_posts());
                }

                Accordion.init();
                Blog.init();
                InfoButtons.init();
                LineClamp.init();
                NetworkMasonry.init();

                if(options.load_more_button && options.loading) {
                    if(container) {
                        //enablePageScroll();
                        this_height = container.offsetHeight;
                        // window.scrollTo(0, (this_height - previous_height) + container_top);
                        // window.scrollBy(0, previous_height - this_height)
                        window.scrollTo(0, last_scroll);
                    }
                }
            }
        })
    }

    select_from_dropdown(event, category) {
        var value = event.target.value;
        console.log("Category: " + category + ", value: " + value);
    }

    //TODO: Divide posts by 10/20 w/e and select an offset based on the pagination, Now done via PHP.
    //TODO: Pagination links.
    //TODO: new query from database based on the drop down menus.
    //TODO: update the contents of the page based on the selected offset.

    set_posts(the_posts) {
        this.posts = the_posts;
    }

    get_posts() {
        return this.posts;
    }

    set_max_posts(count) {
        this.max_posts = count;
    }

    get_max_posts() {
        return this.max_posts;
    }

    convertToJSON(the_posts) {
        set_posts(the_posts);
        // console.log("This website: ", window.location.origin);
        console.log("GOT POSTS", posts);
    }

}